import { RPPI } from '@/core/interfaces/rpp.interface'
import {
    GetLtlRppBidResponse,
    GetLtlRppCostComparisonResponse,
    GetLtlRppDetailsResponse,
    GetLtlRppParams,
    GetLtlRppResponse,
    RPPCashFlowsListResponseT,
    RPPExportExcelPayloadT,
    RPPExportExcelResponseT,
    RPPListParamsT,
    RPPListResponseT,
    RPPOrdersListParamsT,
    RPPOrdersListResponseT,
    RPPPayloadT,
    RPPResponseT,
    RppSubmitPayload,
} from '@/core/types/rpp.types'
import { RPPService } from '@/core/services/rpp.service'

const rppService = new RPPService()

class RppRealisation implements RPPI {
    getCashFlows(): Promise<RPPCashFlowsListResponseT> {
        return rppService.getCashFlows()
    }

    getRPPOrdersList(params: RPPOrdersListParamsT): Promise<RPPOrdersListResponseT> {
        return rppService.getRPPOrdersList(params)
    }

    getRPPList(params: RPPListParamsT): Promise<RPPListResponseT> {
        return rppService.getRPPList(params)
    }

    getRPP(id: number): Promise<RPPResponseT> {
        return rppService.getRPP(id)
    }

    createRPP(payload: RPPPayloadT): Promise<void> {
        return rppService.createRPP(payload)
    }

    submitRpp(payload: RppSubmitPayload): Promise<void> {
        return rppService.submitRpp(payload)
    }

    editRPP(payload: RPPPayloadT): Promise<void> {
        return rppService.editRPP(payload)
    }

    changeCompany(id: number, companyId: number): Promise<void> {
        return rppService.changeCompany(id, companyId)
    }

    changeStatusRPP(rpp_id: number, status_code: string): Promise<void> {
        return rppService.changeStatusRPP(rpp_id, status_code)
    }

    exportExcel(params: RPPExportExcelPayloadT): Promise<RPPExportExcelResponseT> {
        return rppService.exportExcel(params)
    }

    exportLTLExcel(params: RPPExportExcelPayloadT): Promise<RPPExportExcelResponseT> {
        return rppService.exportLTLExcel(params)
    }

    exportLtlByIdExcel(id: number): Promise<RPPExportExcelResponseT> {
        return rppService.exportLtlByIdExcel(id)
    }

    deleteRpp(id: number): Promise<void> {
        return rppService.deleteRpp(id)
    }

    getLtlRppList(params: GetLtlRppParams): Promise<GetLtlRppResponse> {
        return rppService.getLtlRppList(params)
    }

    getLtlRppCostComparison(id: number): Promise<GetLtlRppCostComparisonResponse> {
        return rppService.getLtlRppCostComparison(id)
    }

    getLtlRpp(ltl_rpp_id: number): Promise<GetLtlRppDetailsResponse> {
        return rppService.getLtlRpp(ltl_rpp_id)
    }

    getLtlRppBid(trip_id: number): Promise<GetLtlRppBidResponse> {
        return rppService.getLtlRppBid(trip_id)
    }
}

export const rpp = new RppRealisation()
